import { render, staticRenderFns } from "./QuestionTypeFreeTextYoutubeLink.vue?vue&type=template&id=9423519a"
import script from "./QuestionTypeFreeTextYoutubeLink.vue?vue&type=script&lang=js"
export * from "./QuestionTypeFreeTextYoutubeLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports